export default {
  title: 'ダッシュボード',
  loadingStatus: 'データ読み込み中',
  syncedStatus: 'データ同期済み',
  refresh: '更新',
  notRefreshed: '未更新',
  lastRefreshedAt: '最終更新 {time}',
  todayScanCount: '本日スキャン数',
  todayNewMembers: '本日新規会員',
  totalScanCount: 'スキャン総数',
  totalMembers: '会員総数',
  ratioUp: '前期比↑ {value}%',
  quickActions: 'クイック操作',
  actionProducts: '商品管理',
  actionCodeDisable: 'QRコード無効化',
  actionActivity: 'アクティビティ管理',
  actionMemberList: '会員リスト',
  actionPointsMall: 'ポイントモール',
  scanTrend: 'スキャントレンド',
  thisWeek: '今週',
  thisMonth: '今月',
  realtimeScanRecords: 'リアルタイムスキャン記録',
  scanTime: 'スキャン時間',
  userName: 'ユーザー名',
  scanRegion: 'スキャン国/地域',
  legendScanCount: 'スキャン数',
  legendScanUsers: 'スキャンユーザー数',
  legendWinners: '当選者数',
  unit: '個',
};
